import { render, staticRenderFns } from "./team-supervisor-tooltip.vue?vue&type=template&id=2ed9fa88"
import script from "./team-supervisor-tooltip.vue?vue&type=script&lang=js"
export * from "./team-supervisor-tooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports